export default {
    state: {
        viberCampaign: localStorage.getItem('viberCampaign') ? {} : localStorage.getItem('viberCampaign'),
        excludedCampaignIds: localStorage.getItem(' excludedCampaignIds') ? [] : localStorage.getItem('excludedCampaignIds')
    },
    mutations: {
        setViberCampaign(state, campaign) {
            state.viberCampaign = campaign
        },
        setExcludedCampaignIds(state, excludedCampaignIds) {
            state.excludedCampaignIds = excludedCampaignIds
        }
    },
    actions: {
        setCurrentViberCampaign({ commit }, campaign) {
            localStorage.setItem('viberCampaign', campaign)
            commit('setViberCampaign', campaign)
        },
        setCurrentExcludedCampaignIds({ commit }, excludedCampaignIds) {
            localStorage.setItem('excludedCampaignIds', excludedCampaignIds)
            commit('setExcludedCampaignIds', excludedCampaignIds)
        }
    },
    getters: {
        getCurrentViberCampaign: state => state.viberCampaign,
        getCurrentExcludedCampaignIds: state => state.excludedCampaignIds
    }
}
